import { isRequestTable } from '../../Table.utils'
import { TableTextCell } from '../TableTextCell'

function CategoryCell({ context, value, ...cellProps }) {
  return (
    <TableTextCell
      {...cellProps}
      value={isRequestTable(context) ? value?.name : value?.value}
    />
  )
}

export default CategoryCell
